import React from "react";
import "./_404.css";
function _404() {
  return (
    <div className="not-found">
      <h1>404</h1>
      <p>Page Not Found</p>
      <a href="/">Go Back to Home</a>
    </div>
  );
}

export default _404;
